// Firebase configuration and initialization
import { initializeApp } from "firebase/app";
import {
  getAuth,
  connectAuthEmulator,
  GoogleAuthProvider,
} from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Firebase configuration object
// These values should be set in your environment variables
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Google OAuth provider for "Sign in with Google". `select_account` forces
// the account chooser instead of silently reusing a cached Google session.
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

// Connect to Firebase emulators in development/test environments
if (
  process.env.NODE_ENV !== "production" &&
  (process.env.VUE_APP_USE_EMULATORS === "true" ||
    process.env.VUE_APP_USE_FIREBASE_EMULATORS === "true")
) {
  // The modular SDK has no `_delegate` (that was the compat layer), so guard
  // against a hot-reload double-connect with a module flag instead.
  if (!window.__crescendoEmulatorsConnected) {
    window.__crescendoEmulatorsConnected = true;
    connectAuthEmulator(auth, "http://localhost:9099", {
      disableWarnings: true,
    });
    connectFirestoreEmulator(db, "localhost", 8080);
    connectStorageEmulator(storage, "localhost", 9199);
    connectFunctionsEmulator(functions, "localhost", 5001);
  }
}

// Export the app instance as default
export default app;
